import { useAppSelector } from '../../../reducers';
import { isUngatedForInbound25Selector, isUngatedForSeatsSelector } from '../../../selectors/GatingSelectors';
import { skuSelector } from '../../../selectors/ProductsSelectors';
import { SubtextDisplay } from '../../../v2/components/merch-card/subtext-display/SubtextDisplay';
import { isValidProductLevel, isValidSkuCategoryName } from '../../../v2/utils/typeguards';
import { productLineToQuantityName, productLineToSkuCategoryName } from './subtextDisplayUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const SubtextDisplayContainerV1 = ({
  additionalUnitSkuId,
  queryParamTerm,
  productLine,
  productLevel
}) => {
  var _packagedQuantities$f;
  const isSeatsRedesignUngated = useAppSelector(isUngatedForSeatsSelector);
  const isUngatedForInbound25 = useAppSelector(isUngatedForInbound25Selector);
  const quantityPack = useAppSelector(state => {
    if (!additionalUnitSkuId) {
      return null;
    }
    return skuSelector(state, {
      skuId: additionalUnitSkuId
    });
  });
  const includedWithParentProduct = quantityPack === null || quantityPack === void 0 ? void 0 : quantityPack.includedWithProductVersion;
  const skuCategoryName = productLineToSkuCategoryName[productLine];
  const packagedQuantities = quantityPack === null || quantityPack === void 0 ? void 0 : quantityPack.packagedQuantities;
  const searchQuantityName = productLineToQuantityName[productLine];
  const quantityName = packagedQuantities === null || packagedQuantities === void 0 || (_packagedQuantities$f = packagedQuantities.find(q => q.name === searchQuantityName)) === null || _packagedQuantities$f === void 0 ? void 0 : _packagedQuantities$f.name;
  if (!isValidProductLevel(productLevel) || !isValidSkuCategoryName(skuCategoryName)) {
    return null;
  }
  return /*#__PURE__*/_jsx(SubtextDisplay, {
    additionalUnitSkuId: additionalUnitSkuId,
    queryParamTerm: queryParamTerm,
    productLevel: productLevel,
    isSeatsUser: isSeatsRedesignUngated,
    isUngatedForInbound25: isUngatedForInbound25,
    skuCategoryName: skuCategoryName,
    includedWithParentProduct: includedWithParentProduct,
    quantityName: quantityName
  });
};